<template>
  <div
    class="custom-template"
    :class="'custom-template-' + variant"
    v-if="messages && Array.isArray(messages) && messages.length > 0"
  >
    <div class="custom-template-content alert alert-danger">
      <div class="custom-template-title mb-3"><u>Error(s)</u></div>
      <ul>
        <li v-for="(message, i) in messages" :key="i + '_' + message">
          {{ message }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Errors",
  props: {
    messages: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      default: "error",
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
